import { getStatusBanner } from 'redux/api/StatusBanner'
import { useThunkActions } from 'redux/actions/useThunkActions'

import { Dispatch } from 'redux'

import * as actions from './actions'

export function tryGetStatusBanner() {
  return (dispatch: Dispatch) => {
    dispatch(actions.get())

    getStatusBanner()
      .then((response) => {
        dispatch(actions.getSuccess(response.data))
      })
      .catch(() => {
        dispatch(actions.getFailed())
      })
  }
}

export const useStatusBannerActions = () => {
  return {
    tryGetStatusBanner: useThunkActions(tryGetStatusBanner)
  }
}
